import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Expertise } from 'src/app/shared/models/expertise';
import { Region } from 'src/app/shared/models/region';
import { Service } from 'src/app/shared/models/service';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';

@Component({
	selector: 'app-service-modal-ajout',
	templateUrl: './service-modal-ajout.component.html',
	styleUrls: ['./service-modal-ajout.component.scss']
})
export class ServiceModalAjoutComponent {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required,
		]),
		type: new FormControl(''),
		handleInfosas: new FormControl(),
		typeHandicap: new FormControl(),
		responsable: new FormControl(''),
		cotraitant: new FormControl(),
		mailDiffusion: new FormControl('')
	});

	listRegion: Region[];
	listExpertise: Expertise[];
	listSelectedRegion: Region[] = [];
	listSelectedExpertiseQD: Expertise[] = [];
	listSelectedExpertiseAC: Expertise[] = [];
	listSelectedExpertiseAS: Expertise[] = [];
	listSelectedExpertiseEAP: Expertise[] = [];
	listSelectedExpertiseCAMEO: Expertise[] = [];
	listSelectedExpertiseSUIVI: Expertise[] = [];
	listTypeHandicap : TypeHandicap[];

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.facade.regionService.getAllRegion().subscribe({
			next: (val) => {
				this.listRegion = val;
			},
			error: (err) => {
				this.logger.error(err);
			}
		});

		this.facade.expertiseService.getAllExpertises().subscribe({
			next: (val) => {
				this.listExpertise = val;
			},
			error: (err) => {
				this.logger.error(err);
			}
		});

		this.facade.typeHandicapService.getAllTypeHandicaps().subscribe({
			next: (val) => {
				this.listTypeHandicap = val;
			},
			error: (err) => {
				this.logger.error(err);
			}
		});
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		const service = new Service();
		service.regions = this.listSelectedRegion;
		service.name = this.formEdit.get('name').value;
		service.type = this.formEdit.get('type').value;
		service.handleInfosas = this.formEdit.get('handleInfosas').value;
		service.cotraitant = this.formEdit.get('cotraitant').value;
		service.responsable = this.formEdit.get('responsable').value;
		service.typeHandicap = this.listTypeHandicap.find(x => x.id == this.formEdit.get('typeHandicap').value); 
		service.mailDiffusion = this.formEdit.get('mailDiffusion').value;
		this.facade.serviceService.addService(service).subscribe({
			next: (succ) => {
				this.bsModalRef.hide();
				// this.isValidateButtonClicked=false;
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.logger.error(err);
			}
		});
	}

	isRegionCheck(reg: Region): boolean {
		return this.listSelectedRegion?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedRegion(e: any, reg: Region) {
		if (e.target.checked) {
			if (!this.listSelectedRegion.some((z) => z.id === reg.id)) {
				this.listSelectedRegion.push(reg);
			}
		} else {
			if (this.listSelectedRegion.some((z) => z.id === reg.id)) {
				this.listSelectedRegion = this.listSelectedRegion.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseQDCheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseQD?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseQD(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseQD.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseQD.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseQD.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseQD = this.listSelectedExpertiseQD.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseASCheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseAS?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseAS(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseAS.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseAS.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseAS.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseAS = this.listSelectedExpertiseAS.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseACCheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseAC?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseAC(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseAC.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseAC.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseAC.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseAC = this.listSelectedExpertiseAC.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseEAPCheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseEAP?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseEAP(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseEAP.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseEAP.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseEAP.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseEAP = this.listSelectedExpertiseEAP.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseCAMEOCheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseCAMEO?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseCAMEO(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseCAMEO.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseCAMEO.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseCAMEO.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseCAMEO = this.listSelectedExpertiseCAMEO.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseSUIVICheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseSUIVI?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseSUIVI(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseSUIVI.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseSUIVI.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseSUIVI.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseSUIVI = this.listSelectedExpertiseSUIVI.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	get name() {
		return this.formEdit.get('name');
	}
	get type() {
		return this.formEdit.get('type');
	}
	get handleInfosas() {
		return this.formEdit.get('handleInfosas');
	}
	get responsable() {
		return this.formEdit.get('responsable');
	}
	get typeHandicap() {
		return this.formEdit.get('typeHandicap');
	}
	get cotraitant() {
		return this.formEdit.get('cotraitant');
	}
	get mailDiffusion() {
		return this.formEdit.get('mailDiffusion');
	}
}
